import React from 'react'
import './index.scss'
import { ILLUSTRATIONS } from '@Const/common'
import ButtonRegistrationRightsHolder from '@Components/Buttons/ButtonRegistrationRightsHolder'

const AddRightsholderCard = () => (
    <section className="add-rightsholder-card">
        <div className="info">
            <h1>Add a Member account</h1>
            <p>
                A Member is a person or entity that administers musical works and receives the digital audio mechanical
                royalties from their use.
            </p>
            <ButtonRegistrationRightsHolder mainColor={false} />
        </div>
        <img src={ILLUSTRATIONS.illustration4} alt="img" />
    </section>
)

export default AddRightsholderCard
